import request from "@/utils/request";

export function search(params) {
  return request({
    url: "/distinct_contract_supplier_accounts?search=" + params,
    method: "get"
  });
}
